import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { BsChevronDown } from "react-icons/bs";
import ReactPaginate from "react-paginate";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const Pagination = ({
  perPage,
  currentPage,
  setCurrentPage,
  setPerPage,
  totalPages,
}) => {
  const refPaymentTypeDropDownContainer = useRef();

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("To Do List").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const [showItem, setShowItem] = useState(false);
  const PaginationChange = (event) => {
    setCurrentPage(event.selected);
  };
  const handleMouseDowFun = (event) => {
    if (
      refPaymentTypeDropDownContainer.current &&
      !refPaymentTypeDropDownContainer.current.contains(event.target)
    ) {
      setShowItem(false);
    }
  };

  useEffect(() => {
    if (showItem) {
      window.addEventListener("mousedown", handleMouseDowFun);
    } else {
      window.addEventListener("mousedown", handleMouseDowFun);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDowFun);
    };
  }, [showItem]);

  return (
    <Row className="d-flex justify-content-between">
      <Col xs={6} xl={3} className="d-flex align-items-center">
        <div
          className="fw-bold  "
          style={{
            fontSize: "20px",
            color: "#333333",
            display: "flex",
          }}
        >
          <p
            className="table-item mb-0"
            style={{
              fontWeight: 400,
              fontSize: "clamp(10px, 0.729vw, 0.729vw)",
            }}
          >
            {/* Items per page */}
            {t("Items per page")}
          </p>

          <div
            style={{
              cursor: "pointer",
              position: "relative",
              display: "flex",
              flexDirection: "row",
              gap: "13px",
            }}
            className="ms-4"
          >
            <p
              className="margin-0"
              style={{
                fontSize: "clamp(10px, 0.729vw, 0.729vw)",
                fontWeight: "bold",
                color: "#333333",
                flexGrow: "1",
                textTransform: "capitalize",
              }}
              onClick={() => setShowItem(!showItem)}
            >
              {perPage}
            </p>
            {/* <BsChevronDown
                            size={10}
                            style={{
                                flexGlow: "1",
                                color: "#333333",
                            }}
                            onClick={() => setShowItem(!showItem)}
                            className="down-arrow bi-paperclip ms-1"
                        /> */}
            <div className="pagination-filter">
              <BsChevronDown
                onClick={() => setShowItem(!showItem)}
                className={`${
                  showItem
                    ? "down-arrow down-arrow-rotate bi-paperclip "
                    : "down-arrow bi-paperclip"
                } table-filter-sub-icon cursors-pointer`}
              />
            </div>
            {showItem && (
              <div
                className="drop-down-member-item d-flex align-items-end p-1 pagination-filter-wrapper"
                id="lang-drop-down"
                ref={refPaymentTypeDropDownContainer}
              >
                <div>
                  {[10, 20, 50]?.map((item, i) => {
                    return (
                      <div>
                        <p
                          key={i}
                          className="margin-0 ms-2 pb-1"
                          style={{
                            opacity: 1,
                            fontSize: "clamp(10px, 0.729vw, 0.729vw)",
                            fontWeight: `${item === perPage ? 800 : "bold"}`,
                            color: `${
                              item === perPage ? "#95A7C6" : "#333333"
                            }`,
                          }}
                          onClick={() => {
                            setPerPage(item);
                            setShowItem(false);
                            setCurrentPage(0);
                          }}
                        >
                          {item}
                        </p>
                      </div>
                    );
                  })}
                </div>
                <div className="pagination-filter-sub">
                  <BsChevronDown className="down-arrow down-arrow-rotate bi-paperclip" />
                </div>
              </div>
            )}
          </div>
        </div>
      </Col>
      <Col xs={6} xl={3} className="add-col-item">
        <div className="table-filter-info-member">
          <ReactPaginate
            nextLabel=""
            forcePage={currentPage}
            disableInitialCallback={true}
            onPageChange={PaginationChange}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            pageCount={totalPages}
            previousLabel=""
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="d-none"
            nextClassName="d-none"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="app-pagination"
            activeClassName="active"
            renderOnZeroPageCount={null}
          />
        </div>
      </Col>
    </Row>
  );
};

export default Pagination;
